import "style!css!resources/bootstrap/css/bootstrap.css";
import "resources/sass/main.sass";
import "style!css!react-simpletabs/dist/react-simpletabs.css";
import React from "react";
import { render } from "react-dom";
import routes from "./sdk-routes";
import { Router, useRouterHistory } from "react-router"
import { createHashHistory } from "history"
import UserHandler from "js/utilities/user-handler";
import ga from "react-ga";
import * as config from "js/config";

if (FN_MODE == "production") {
  ga.initialize((GA_TOKEN), {
    debug: config.GA_DEBUG
  });
}

const appHistory = useRouterHistory(createHashHistory)({ queryKey: false })

render(<Router history={appHistory} routes={routes} onUpdate={logPageView} />, document.getElementById("root"));

function logPageView() {
  ga.pageview(this.state.location.pathname);
}



// WEBPACK FOOTER //
// ./src/js/index.jsx